import { DAY_IN_MILLISECONDS } from "../constants/datetime"
import { logError } from "../utils/errorHandlingUtils"
import { firebaseFetch} from "../utils/firebase"

export const SAVE_COUNTRIES = 'SAVE_COUNTRIES'

export const saveCountries = (countries=[]) => {
    return {
        type: SAVE_COUNTRIES,
        payload: {
            countries
        }
    }
}

export const httpFetchSaveCountry = (
    countryId="",
    onSuccess = () => {
    },
    onError = () => {
    }
) => {
    if (!countryId) return false
    return async (dispatch, getState) => {
        try {
            //only load the country once a day
            const {countries} = getState()
            const {countriesById={}} = countries || {}
            if (
                countriesById[countryId] && 
                ((Date.now() - countriesById[countryId].lastLoadedAt) < DAY_IN_MILLISECONDS)
            ) return true
            //load the country
            const country = await firebaseFetch(
                "countries", 
                countryId,
            )
            if (country) {
                dispatch(saveCountries([country]))
            } else throw new Error(`Country does not exist`)
            onSuccess(countryId)
            return true
        } catch (e) {
            const message = `action > countries > httpFetchSaveCountry: Failed to save country ${countryId}`
            if (e.message_) {
                //deal with firebase-specific errors
                logError(new Error(`${e.message} ${message}`))
            } else {
                e.message = `${e.message} ${message}`
                logError(e)
            }
            onError(countryId)
            return false
        }
    }
}